import React from "react";

const SearchInput = ({ id, placeholder, value, onChange, label }) => {
  return (
    <div className="mt-4 space-y-2">
      {label && (
        <label htmlFor={id} className="block text-lg font-medium text-gray-700">
          {label}
        </label>
      )}
      <input
        id={id}
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className="w-full px-3 py-2 sm:px-4 sm:py-2 border border-gray-300 rounded-md 
                  focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent
                  transition-all duration-200 shadow-sm
                  text-sm sm:text-base
                  sm:max-w-md lg:max-w-sm"
      />
    </div>
  );
};

export default SearchInput;
